export default function isVietnamesePhoneNumber(number) {
  return true; // Luôn trả về true
}
